import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    dismissLabel: string;
    message: string | React.ReactNode;
    ctaLabel: string;
    iconAlt: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessible label for the button that dismisses the Frame.io Drive toast */
            dismissLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DriveFloatingToast.dismissLabel?c=12vpt6ppn1wyz", defaultMessage: "Dismiss" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Frame.io Drive toast body copy; "NEW" is emphasized */
            message: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DriveFloatingToast.message?c=8e6xzp1i55t9", defaultMessage: "<jsx><strong>NEW</strong> Mount this project directly on your desktop.</jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), strong: (__children__: React.ReactNode) => <strong>{React.Children.toArray(__children__)}</strong> }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the button that takes the user to get Frame.io Drive */
            ctaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DriveFloatingToast.ctaLabel?c=136727h1nabg6", defaultMessage: "Get Frame.io Drive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Alt text for the Frame.io Drive app icon */
            iconAlt: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DriveFloatingToast.iconAlt?c=16hrixlvn0l8d", defaultMessage: "Frame.io Drive" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
